import { StatusFilter } from '@/lib/filter/stakingPoolState';
import { unixToDate } from '@/lib/days';
import { EvmTxHistory, ResGetPoolDetailsAndEvmTxHistory } from '@/types';
import { useEffect, useState } from 'react';
import { useWeb3 } from '@/hooks/use-web3';
import { promiseStatus } from '@/lib/Promise';
import { GETPOOLDETAILS } from '@/lib/common/name-space';

import { walletState } from '@/atom/wallet';

import { Avatar, Box, Card, Typography, useTheme } from '@mui/material';
import { useRecoilState } from 'recoil';
import PortfolioTable from './table/portfolio/PortfolioTable';
export default function PoolHistory({ aList, aAddress }: { aList: EvmTxHistory[] | null; aAddress: string }) {
  const [list, setList] = useState<ResGetPoolDetailsAndEvmTxHistory[] | null>(null);
  const [wallet, setWallet] = useRecoilState(walletState);
  const { web3authCall } = useWeb3();
  const theme = useTheme();

  useEffect(() => {
    if (!aList) {
      return;
    }
    if (list) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        await txHistory(aList);
      }
    })();
    return () => {};
  }, [web3authCall, aList]);

  const txHistory = async (aList: EvmTxHistory[]) => {
    const filter = await Promise.allSettled(
      aList
        .filter(
          (item: EvmTxHistory) =>
            item.isError === '0' &&
            (item.functionName.startsWith('stakeToken') ||
              item.functionName.startsWith('claimReward') ||
              item.functionName.startsWith('unStakeToken') ||
              item.functionName.startsWith('claimAllReward') ||
              item.methodId.startsWith('0x8448705b')),
        )
        .map(async (item: EvmTxHistory, index: number) => {
          const re = await web3authCall?.callStaking(GETPOOLDETAILS, item.to);
          return { ...item, ...re };
        }),
    );
    const result: ResGetPoolDetailsAndEvmTxHistory[] = promiseStatus(filter);
    setList(result);
  };

  return (
    <>
      {aAddress ? (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            marginBottom: '280px',
            padding: { xs: '16px 24px', md: '20px 24px' },
          }}
        >
          <Typography sx={{ marginBottom: '24px' }} variant="h3" color={theme.greyscale.darkgrey2}>
            Transaction History
          </Typography>
          <PortfolioTable aList={list} />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            marginBottom: '280px',
            padding: { xs: '16px', md: '20px 24px' },
          }}
        >
          <Typography sx={{ marginBottom: '24px' }} variant="h3" color={theme.greyscale.darkgrey2}>
            Transaction History
          </Typography>
          <Box
            sx={{
              background: '#357AFF1A',
              borderRadius: '10px',
              padding: '10px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              No Transaction displayed yet
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
